import { render, staticRenderFns } from "./StudentIndicator.vue?vue&type=template&id=6812d649&scoped=true"
import script from "./StudentIndicator.vue?vue&type=script&lang=ts"
export * from "./StudentIndicator.vue?vue&type=script&lang=ts"
import style0 from "./StudentIndicator.vue?vue&type=style&index=0&id=6812d649&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6812d649",
  null
  
)

export default component.exports